"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var SubstitutionTokenId_1 = __importDefault(require("Tokens/SubstitutionTokenId"));
var ErrorRecorder_1 = __importDefault(require("Utils/ErrorRecorder"));
var errorRecorder = new ErrorRecorder_1.default();
var create = function (id, name, dataType, providerType, providerData, hierarchyInfo) {
    var substitutionToken = {
        id: id,
        name: name,
        dataType: dataType,
        providerType: providerType,
        providerData: providerData,
    };
    if (hierarchyInfo) {
        substitutionToken.hierarchyInfo = hierarchyInfo;
    }
    return substitutionToken;
};
function isPlatformToken(apiToken) {
    var _a;
    return (_a = apiToken.id) === null || _a === void 0 ? void 0 : _a.startsWith("token");
}
function generateFromPlatformToken(apiToken) {
    return {
        id: apiToken.id,
        dataType: apiToken.dataType,
        name: removeAnyPrefix(apiToken.name),
        providerType: apiToken.providerType,
        providerData: {
            apiName: apiToken.apiName ? removeAnyPrefix(apiToken.apiName) : apiToken.name,
            objectType: apiToken.objectType,
        },
        hierarchyInfo: apiToken.hierarchyInfo,
    };
}
var fromLegacyApiToken = function (apiToken) {
    if (!isSupportedToken(apiToken)) {
        return undefined;
    }
    if (isPlatformToken(apiToken)) {
        return generateFromPlatformToken(apiToken);
    }
    try {
        validateToken(apiToken);
        apiToken = normaliseToken(apiToken);
        return create(SubstitutionTokenId_1.default.createId(apiToken.providerType, generateIdComponents(apiToken)), apiToken.name.trim(), apiToken.dataType, apiToken.providerType, generateProviderData(apiToken), generateHierarchyInfo(apiToken));
    }
    catch (e) {
        console.error("An error occurred creating a SubstitutionToken", e);
        errorRecorder.recordError(e);
        return undefined;
    }
};
var validateToken = function (apiToken) {
    if (apiToken.dataType === Types_1.TokenDataType.Object) {
        throw new Error("TokenDataType of 'object' is not supported");
    }
};
var generateProviderData = function (apiToken) {
    var providerData = {
        apiName: apiToken.apiName,
    };
    if (apiToken.objectType) {
        providerData.objectType = apiToken.objectType;
    }
    return providerData;
};
var generateHierarchyInfo = function (apiToken) {
    if (apiToken.providerType === Types_1.ProviderType.Custom && apiToken.objectType) {
        return {
            parentId: SubstitutionTokenId_1.default.createId(Types_1.ProviderType.Custom, ["", apiToken.objectType]),
        };
    }
    else if (isHubspotLineItem(apiToken)) {
        return {
            parentId: SubstitutionTokenId_1.default.createId(Types_1.ProviderType.Hubspot, [Types_1.HubspotObjectType.Deal, Types_1.ProductToken]),
        };
    }
    else if (isSaleforceOpportunityLineItem(apiToken)) {
        return {
            parentId: SubstitutionTokenId_1.default.createId(Types_1.ProviderType.Salesforce, [
                Types_1.SalesforceObjectType.Opportunity,
                Types_1.ProductToken,
            ]),
        };
    }
    return;
};
var generateIdComponents = function (apiToken) {
    var _a, _b;
    switch (apiToken.providerType) {
        case Types_1.ProviderType.Hubspot:
        case Types_1.ProviderType.Salesforce:
            return [(_a = apiToken.objectType) !== null && _a !== void 0 ? _a : "", apiToken.apiName];
        case Types_1.ProviderType.Custom:
            return [(_b = apiToken.objectType) !== null && _b !== void 0 ? _b : "", apiToken.apiName];
        default:
            throw new Error("Token ProviderType: '".concat(apiToken.providerType, "' has not been implemented."));
    }
};
var isSupportedToken = function (token) {
    return (!isHubspotRelatedContactToken(token) &&
        !isHubspotRelatedCompanyToken(token) &&
        !isSalesforcePrimaryContactToken(token));
};
var isHubspotRelatedContactToken = function (token) {
    return (token.providerType === Types_1.ProviderType.Hubspot &&
        token.objectType === Types_1.HubspotObjectType.Deal &&
        hasPrefix(token.apiName, Types_1.ContactApiName));
};
var isHubspotRelatedCompanyToken = function (token) {
    return (token.providerType === Types_1.ProviderType.Hubspot &&
        (token.objectType === Types_1.HubspotObjectType.Deal || token.objectType === Types_1.HubspotObjectType.Contact) &&
        hasPrefix(token.apiName, Types_1.CompanyApiName));
};
var isSalesforcePrimaryContactToken = function (token) {
    return (token.providerType === Types_1.ProviderType.Salesforce &&
        token.objectType === Types_1.SalesforceObjectType.Opportunity &&
        hasPrefix(token.apiName, Types_1.PrimaryContactApiName));
};
var normaliseToken = function (token) {
    if (token.providerType === Types_1.ProviderType.Custom && token.objectType && hasPrefix(token.apiName, token.objectType)) {
        var clonedToken = (0, lodash_1.cloneDeep)(token);
        clonedToken.apiName = removePrefix(token.apiName, token.objectType);
        return clonedToken;
    }
    else if ((isSaleforceOpportunityLineItem(token) || isHubspotLineItem(token) || isZohoItemProperty(token)) &&
        hasPrefix(token.apiName, Types_1.ProductToken)) {
        var clonedToken = (0, lodash_1.cloneDeep)(token);
        clonedToken.apiName = removePrefix(token.apiName, Types_1.ProductToken);
        return clonedToken;
    }
    return token;
};
var isSaleforceOpportunityLineItem = function (token) {
    return (token.providerType === Types_1.ProviderType.Salesforce && token.objectType === Types_1.SalesforceObjectType.OpportunityLineItem);
};
var isHubspotLineItem = function (token) {
    return token.providerType === Types_1.ProviderType.Hubspot && token.objectType === Types_1.HubspotObjectType.LineItem;
};
var isZohoItemProperty = function (token) {
    return token.providerType === Types_1.ProviderType.Zoho;
};
var hasPrefix = function (tokenField, prefix) {
    return tokenField.indexOf("".concat(prefix, ".")) === 0;
};
var removePrefix = function (tokenField, prefix) {
    return tokenField.replace("".concat(prefix, "."), "");
};
var removeAnyPrefix = function (tokenField) {
    return (tokenField === null || tokenField === void 0 ? void 0 : tokenField.includes(".")) ? tokenField.split(".")[1] || "" : tokenField;
};
exports.default = { create: create, fromLegacyApiToken: fromLegacyApiToken };
